<tr [ngClass]="cssClassName">
  <td easEditorBookingItemInheritableTypeHeader [inheritableType]="item.bundle.length > 0 ? 'set' : 'empty'" i18n>
    Bundle
  </td>
  <td>
    @if (item.bundle.length === 0) {
      <span class="text-muted">
        @if (!item.bundleIsEditable()) {
          <ng-container i18n>Not available </ng-container>
        }
        @if (item.bundleIsEditable()) {
          <ng-container i18n>Not set </ng-container>
        }
      </span>
    }
    @if (item.bundle.length > 0) {
      <eas-editor-booking-item-bundle-summary [bundle]="item.bundle">
      </eas-editor-booking-item-bundle-summary>
    }
    @if (item.bundleIsEditable()) {
      <button
        mat-icon-button
        aria-label="Edit bundle"
        i18n-aria-label
        (click)="onEdit()">
        <mat-icon>edit</mat-icon>
      </button>
    }
  </td>
  <td>
    @if (item.bundle.length > 0) {
      <eas-editor-booking-item-inheritable-type-badge
        [inheritableType]="'set'">
      </eas-editor-booking-item-inheritable-type-badge>
    }
  </td>
</tr>
